import { AuthorizeHttpClientDecorator } from '@/presentation/main/decorators';
import { makeAxiosHttpClient } from '@/presentation/main/factories/http';
import { useAuth0 } from "@/lib/auth0";
export const makeAuthorizeHttpClientDecorator = () => {
    const { getTokenSilently } = useAuth0();
    return new AuthorizeHttpClientDecorator(makeAxiosHttpClient(), getTokenSilently);
};
